import React from "react";
interface SlideProps {
  title: string;
  subtitle?: string;
  icon?: React.ReactNode;
  content: React.ReactNode;
}
export const Slide = ({
  title,
  subtitle,
  icon,
  content
}: SlideProps) => {
  return <div className="bg-white rounded-xl p-8 shadow-lg min-h-[600px]" data-id="element-1443">
      <div className="text-center mb-8" data-id="element-1444">
        {icon && <div className="flex justify-center mb-4" data-id="element-1445">{icon}</div>}
        <h2 className="text-3xl font-bold text-gray-900 mb-2" data-id="element-1446">{title}</h2>
        {subtitle && <p className="text-xl text-gray-600" data-id="element-1447">{subtitle}</p>}
      </div>
      <div className="max-w-5xl mx-auto" data-id="element-1448">{content}</div>
    </div>;
};